/**
 * QUALI RIPROPOSTE IL GIOCATORE HA GIA' APERTO, in questo browser.
 *
 * Serve a una cosa sola: fermare il lampeggio. La riga lampeggia finche' lui
 * non la APRE (il tasto «Guarda e rispondi» o il ticket); da li' resta accesa
 * fissa, col tempo che scorre, finche' non risponde o scade. Se chiude senza
 * rispondere non riparte: l'ha vista. Riparte solo per una riproposta NUOVA,
 * che ha un altro codice.
 *
 * VIVE NEL BROWSER (sessionStorage per codice del ticket), NON SUL SERVER, e
 * non e' una scorciatoia: su un altro telefono la stessa riga lampeggia di
 * nuovo, ed e' giusto -- li' non l'ha vista. Il server ha `arrivataIl`, che
 * dice che un browser l'ha DISEGNATA, non che lui l'ha letta: sono due cose,
 * e non si inventa un campo per la seconda.
 *
 * Chi la segna avvisa con l'evento `ripropostaVista` sulla finestra, cosi'
 * la striscia sotto la schedina, la lista e la spia si spengono insieme senza
 * conoscersi.
 */

const CHIAVE = 'lvc.riproposte-viste';

function leggi() {
  try {
    const v = JSON.parse(window.sessionStorage.getItem(CHIAVE) || '[]');
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
}

/** Vero se questa riproposta e' gia' stata aperta qui. */
export function ripropostaVista(codice) {
  return !!codice && leggi().includes(codice);
}

/** L'ha aperta: da adesso non lampeggia piu', in questo browser. */
export function segnaRipropostaVista(codice) {
  if (!codice) return;
  const viste = leggi();
  if (viste.includes(codice)) return;
  viste.push(codice);
  try {
    /* Le ultime cinquanta bastano: una riproposta vive minuti, non giorni. */
    window.sessionStorage.setItem(CHIAVE, JSON.stringify(viste.slice(-50)));
  } catch (e) {
    /* niente sessionStorage: lampeggera' un'altra volta, pazienza */
  }
  window.dispatchEvent(new Event('ripropostaVista'));
}

/** Vero se la riga deve lampeggiare: aspetta lui e non l'ha ancora aperta. */
export function daLampeggiare(giocata) {
  return !!giocata && giocata.status === 'RIPROPOSTA' && !ripropostaVista(giocata.ticketCode);
}
